import {EnvironmentProviders} from '@angular/core';
import {
  AimOutline,
  AlertOutline,
  ApartmentOutline,
  AppleFill,
  AppstoreOutline,
  ArrowLeftOutline,
  CloudServerOutline,
  CloudUploadOutline,
  CopyOutline,
  DashboardOutline,
  DeleteOutline,
  DownOutline,
  DownloadOutline,
  ExceptionOutline,
  ExportOutline,
  FileTextOutline,
  FormOutline,
  GlobalOutline,
  GoogleCircleFill,
  GroupOutline,
  InfoCircleTwoTone,
  KeyOutline,
  LaptopOutline,
  LinkOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MinusCircleOutline,
  MinusOutline,
  NotificationOutline,
  PieChartOutline,
  PlusOutline,
  RedoOutline,
  SafetyCertificateOutline,
  SearchOutline,
  ShopOutline,
  StopOutline,
  TeamOutline,
  ThunderboltOutline,
  TranslationOutline,
  UploadOutline,
  UserOutline,
  WarningOutline,
} from '@ant-design/icons-angular/icons';
import {provideNzIcons as provideNzIconsFromNgZorro} from 'ng-zorro-antd/icon';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  GlobalOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  UserOutline,
  AlertOutline,
  CloudServerOutline,
  CloudUploadOutline,
  CopyOutline,
  InfoCircleTwoTone,
  RedoOutline,
  LinkOutline,
  ExportOutline,
  DownOutline,
  ApartmentOutline,
  PieChartOutline,
  NotificationOutline,
  GroupOutline,
  ExceptionOutline,
  AppstoreOutline,
  TranslationOutline,
  PlusOutline,
  MinusCircleOutline,
  MinusOutline,
  UploadOutline,
  DownloadOutline,
  ArrowLeftOutline,
  WarningOutline,
  AimOutline,
  AppleFill,
  GoogleCircleFill,
  SearchOutline,
  ThunderboltOutline,
  ShopOutline,
  FileTextOutline,
  TeamOutline,
  SafetyCertificateOutline,
  KeyOutline,
  LaptopOutline,
  StopOutline,
];

export function provideNzIcons(): EnvironmentProviders {
  return provideNzIconsFromNgZorro(icons);
}
